import type { FarewellScreenProps } from './types';

export function useFarewellController(props: FarewellScreenProps) {
  return {
    logoUrl: props.logoUrl,
  };
}
